<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('customers')">Customers</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="customer.deleted_at" class="mb-6" @restore="restore">
      This customer has been deleted.
    </trashed-message>
    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <text-input v-model="form.name" :errors="$page.props.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Customer Account Name" />
              <text-input v-model="form.tin_number" :errors="$page.props.errors.tin_number" class="pr-6 pb-8 w-full lg:w-1/2" label="TIN Number" />
              <text-input v-model="form.ls_number" :errors="$page.props.errors.ls_number" class="pr-6 pb-8 w-full lg:w-1/2" label="LS Number" />
              <select-input v-model="form.location" :errors="$page.props.errors.location" class="pr-6 pb-8 w-full lg:w-1/2" label="Location">
                <option :value="null" />
                <option v-for="(location, lcode) in $page.props.locations" :value="lcode" :key="lcode">{{ location }}</option>
              </select-input>
              <div class="w-full  lg:w-1/2 pr-6 pb-8">
                  <select-input v-model="form.status" :errors="$page.props.errors.status" class="w-full" label="Status">
                      <option :value="null" />
                      <option v-for="(status, skey) in $page.props.statuses" :value="skey" :key="skey">{{ status }}</option>
                  </select-input>
                  <p v-if="customer.status === 'approved'" class="text-sm leading-normal">Approved by {{ customer.approved_by }}</p>
              </div>
          </div>
        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
          <button v-if="!customer.deleted_at && canAdmin('delete-customers')" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Customer</button>
          <loading-button :loading="sending" class="btn-primary ml-auto" type="submit">Update Customer</loading-button>
        </div>
      </form>
    </div>
    <h2 class="mt-12 font-bold text-2xl">Delivery Addresses</h2>
    <div class="mt-6 flex flex-row flex-wrap">
      <delivery-address-card v-for="address in customer.addresses" :key="address.id" :address="address"></delivery-address-card>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'
import DeliveryAddressCard from '@/Shared/DeliveryAddressCard'
import Toggle from '@/Shared/Toggle'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  layout: Layout,
  components: {
    DeliveryAddressCard,
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    DeliveryAddressCard,
    Toggle
  },
  props: {
    customer: Object,
    statuses: Object
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {
        name: this.customer.name,
        ls_number: this.customer.ls_number,
        tin_number: this.customer.tin_number,
        location: this.customer.location,
        status: this.customer.status,
        bypass_daily_order_limit: this.customer.bypass_daily_order_limit
      }
    }
  },
  methods: {
    submit() {
      this.sending = true
      this.$inertia.put(this.route('customers.update', this.customer.id), this.form,{
        onFinish : () => this.sending = false
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this customer?')) {
        this.$inertia.delete(this.route('customers.destroy', this.customer.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this customer?')) {
        this.$inertia.put(this.route('customers.restore', this.customer.id))
      }
    },
  },
}
</script>
